<div class="dialog-form">
  <div class="cancel-result-container">
    <section class="container-fluid no-breadcrumbs">

      <p-fieldset class="summary-fieldset">
        <p-header>
          <h3 class="article-title">
            <i class="pi pi-chart-bar" style="margin-right: 8px;"></i>
            Resumo do Cancelamento
          </h3>
        </p-header>
        <div class="summary-cards">
          <div class="summary-card">
            <div class="summary-icon requested">
              <i class="pi pi-list"></i>
            </div>
            <div class="summary-content">
              <div class="summary-label">Faturas solicitadas</div>
              <div class="summary-value">{{ totals.requested }}</div>
            </div>
          </div>
          <div class="summary-card">
            <div class="summary-icon canceled">
              <i class="pi pi-check"></i>
            </div>
            <div class="summary-content">
              <div class="summary-label">Canceladas</div>
              <div class="summary-value">{{ totals.canceled }}</div>
            </div>
          </div>
          <div class="summary-card">
            <div class="summary-icon skipped">
              <i class="pi pi-minus-circle"></i>
            </div>
            <div class="summary-content">
              <div class="summary-label">Ignoradas</div>
              <div class="summary-value">{{ totals.skipped }}</div>
            </div>
          </div>
          <div class="summary-card">
            <div class="summary-icon errors">
              <i class="pi pi-times"></i>
            </div>
            <div class="summary-content">
              <div class="summary-label">Com erro</div>
              <div class="summary-value">{{ totals.errors }}</div>
            </div>
          </div>
          <div class="summary-card">
            <div class="summary-icon orders">
              <i class="pi pi-shopping-cart"></i>
            </div>
            <div class="summary-content">
              <div class="summary-label">Pedidos cancelados</div>
              <div class="summary-value">{{ totals.ordersCanceled }}</div>
            </div>
          </div>
          <div class="summary-card">
            <div class="summary-icon copies">
              <i class="pi pi-copy"></i>
            </div>
            <div class="summary-content">
              <div class="summary-label">Pedidos recriados</div>
              <div class="summary-value">{{ totals.ordersCopied }}</div>
              <div class="summary-note" *ngIf="hasTuitionOrders">
                {{ totals.tuitionOrdersNotRecreated }} de mensalidade não são recriados
              </div>
            </div>
          </div>
        </div>

        <p-message severity="info" styleClass="tuition-notice" *ngIf="hasTuitionOrders"
          [text]="tuitionNoticeText">
        </p-message>
      </p-fieldset>

      <p-fieldset *ngIf="showInvoicesAsTable" class="invoices-fieldset">
        <p-header>
          <h3 class="article-title">
            <i class="pi pi-file" style="margin-right: 8px;"></i>
            Faturas ({{ invoices.length }})
          </h3>
        </p-header>
        <p-table [value]="invoices" [paginator]="invoices.length > 20" [rows]="20"
                 [rowsPerPageOptions]="[10, 20, 50, 100]" styleClass="p-datatable-sm invoices-table"
                 [scrollable]="true" scrollHeight="400px">
          <ng-template pTemplate="header">
            <tr>
              <th style="width: 110px">Fatura</th>
              <th>Cliente</th>
              <th style="width: 130px">Desfecho</th>
              <th style="width: 190px">Financeiro</th>
              <th>Pedidos cancelados</th>
              <th style="width: 110px" class="text-center">Recriados</th>
              <th>Motivo</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-item>
            <tr>
              <td>
                <span class="invoice-number" [title]="'ID: ' + item.invoiceId">
                  {{ item.invoiceNumber || item.invoiceId }}
                </span>
              </td>
              <td>{{ item.customerName || '—' }}</td>
              <td>
                <span class="badge status-badge" [ngClass]="outcomeClass(item)">
                  <i [class]="outcomeIcon(item)"></i>
                  {{ outcomeLabel(item) }}
                </span>
              </td>
              <td>
                <span class="badge status-badge" [ngClass]="financesClass(item)">
                  {{ financesLabel(item) }}
                </span>
              </td>
              <td>
                <span class="id-list">{{ ordersLabel(item) }}</span>
              </td>
              <td class="text-center">
                <span class="count-badge">{{ item.ordersCopied }}</span>
                <div class="tuition-hint" *ngIf="item.tuitionOrdersNotRecreated > 0"
                     [pTooltip]="'Pedido de mensalidade não é recriado no cancelamento — a mensalidade é cancelada junto.'"
                     tooltipPosition="left">
                  {{ recreatedDetail(item) }}
                </div>
              </td>
              <td>
                <span class="reason" [title]="item.reason">{{ item.reason || '—' }}</span>
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr>
              <td colspan="7">Nenhuma fatura registrada neste processo.</td>
            </tr>
          </ng-template>
        </p-table>
      </p-fieldset>

      <p-fieldset class="log-fieldset">
        <p-header>
          <h3 class="article-title">
            <i class="pi pi-list" style="margin-right: 8px;"></i>
            Log de Execução ({{ logActions.length }} ações)
          </h3>
        </p-header>
        <div class="log-container">
          <div class="log-timeline">
            <div class="log-item" *ngFor="let action of logActions; let i = index"
                 [ngClass]="getActionClass(action.description)">
              <div class="log-marker">
                <i [class]="getActionIcon(action.description)"></i>
              </div>
              <div class="log-content">
                <div class="log-header">
                  <span class="log-description">{{ action.description }}</span>
                  <span class="log-time" *ngIf="i > 0">+{{ getTimeDifference(i) }}</span>
                </div>
                <div class="log-datetime">
                  <i class="pi pi-clock"></i>
                  {{ formatDateTime(action.datetime) }}
                </div>
              </div>
            </div>
          </div>
          <div class="empty-log" *ngIf="logActions.length === 0">
            Nenhuma ação registrada.
          </div>
        </div>
      </p-fieldset>

    </section>
  </div>
</div>
